import {attr, Model} from 'redux-orm';
import {createAction} from '@reduxjs/toolkit';
import flatMap from 'array.prototype.flatmap';

// =====ACTIONS=====
export const createUsers = createAction('models/users/createUsers');
export const updateDevices = createAction('models/users/updateDevices');
export const clearUsers = createAction('models/users/clearUsers');

// =====MODEL=====

class Users extends Model {
    static modelName = 'Users';

    static fields = {
        type: attr(),
    };

    static reducer({type, payload}, Users, session) {
        switch (type) {
            case createUsers.type: {
                const {userData, devicesData} = payload;

                const usersInCircles = flatMap(userData, circle => circle.user);
                const usersWithDevices = flatMap(devicesData, device => device.owner_id);
                const usersIDs = flatMap(usersInCircles, user => user.id);

                const uniqueUserIDs = [...new Set(usersIDs)];
                const uniqueUsers = uniqueUserIDs.map(i => usersInCircles.find(user => user.id === i));

                return uniqueUsers.forEach(i => {
                    if (i.parent_id === 0) {
                        return Users.upsert({
                            ...i,
                            type: 'user'
                        })
                    }

                    if (usersWithDevices.includes(i.id)) {
                        Users.upsert({
                            ...i,
                            type: 'device'
                        })
                    }
                })
            }

            case updateDevices.type: {
                return payload.forEach(item => {

                    Users.upsert({
                        id: item.owner_id,
                        modelName: item.resources.model_name,
                        deviceIcon: item.resources.img_small,
                        battery_level: item.battery_level,
                        data_plan: item.data_plan
                    });
                });
            }

            case clearUsers.type: {
                return Users.delete();
            }
            default:
                break;
        }
    }
}

export default Users;
